import React, { useState } from "react";
import { PlansGrid } from "./components/PlansGrid";
import { PlanSelectionFooter } from "./components/PlanSelectionFooter";
import { cn } from "../../../lib/utils";
import { waToggle } from "../../../pages/whatsapp/utils/whatsappUiTokens";

export const PlanSelection = ({
  plans,
  billingTabs = [],
  selectedPlan,
  onSelectPlan,
  onContinue,
  gstRate = 0.18,
  disabled = false,
  hasActivePlan = false,
  activePlanId = null,
}) => {
  const [activeCycle, setActiveCycle] = useState("MONTHLY");

  const displayedPlans = plans.filter((p) => p.billingCycle === activeCycle);
  const yearlyTab = billingTabs.find((tab) => tab.id === "YEARLY");
  const yearlyBadgeText = yearlyTab?.badge?.text;

  return (
    <div className="flex flex-col gap-5">
      {billingTabs?.length > 0 && (
        <div className="flex justify-end">
          <div className="inline-flex items-center bg-gray-100 dark:bg-slate-800 p-1 rounded-lg border border-gray-200 dark:border-slate-700">
            <button
              type="button"
              onClick={() => setActiveCycle("MONTHLY")}
              className={cn(
                "px-4 py-1.5 text-sm rounded-md transition-all",
                activeCycle === "MONTHLY" ? waToggle.selected : waToggle.unselected
              )}
            >
              Monthly
            </button>
            <button
              type="button"
              onClick={() => setActiveCycle("YEARLY")}
              className={cn(
                "px-4 py-1.5 text-sm rounded-md transition-all inline-flex items-center gap-1.5",
                activeCycle === "YEARLY" ? waToggle.selected : waToggle.unselected
              )}
            >
              Yearly
              {yearlyBadgeText && (
                <span
                  className={cn(
                    "text-[10px] font-bold px-1.5 py-0.5 rounded",
                    activeCycle === "YEARLY"
                      ? "bg-white/20 text-slate-100"
                      : "bg-[hsl(158,48%,36%)]/15 text-[hsl(158,48%,32%)] dark:text-[hsl(158,45%,55%)]"
                  )}
                >
                  {yearlyBadgeText}
                </span>
              )}
            </button>
          </div>
        </div>
      )}

      <PlansGrid
        plans={displayedPlans}
        selectedPlan={selectedPlan}
        onSelectPlan={onSelectPlan}
        gstRate={gstRate}
        hasActivePlan={hasActivePlan}
        activePlanId={activePlanId}
      />

      <PlanSelectionFooter
        selectedPlan={selectedPlan}
        onContinue={onContinue}
        disabled={disabled}
        hasActivePlan={hasActivePlan}
      />
    </div>
  );
};
